import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getAuthError, getPendingEmail, getUserLoadingState, verifyAddedEmail } from '../../../store/slices/authSlice';
import CustomButton, { BUTTON_STYLE_TYPE } from '../../common/Button';
import OtpCodeInput from './OtpCodeInput';
import styles from './styles.module.scss';

const CODE_LENGTH = 6;

const VerifyAddedEmailStep = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const email = useSelector(getPendingEmail);
    const loading = useSelector(getUserLoadingState);
    const error = useSelector(getAuthError);
    const [code, setCode] = useState('');

    const onSubmit = (event) => {
        event.preventDefault();
        if (loading || code.length !== CODE_LENGTH) {
            return;
        }
        dispatch(verifyAddedEmail(code));
    };

    return (
        <>
            <h2 className={`${styles.title} ${styles.titleMixedCase}`}>{t('modal.verifyEmailTitle')}</h2>
            <p className={styles.subtitle}>{t('modal.verifyEmailLabel', { email })}</p>
            <form onSubmit={onSubmit}>
                <OtpCodeInput value={code} onChange={setCode} disabled={loading} />
                {error && <p className={styles.formError}>{error.message}</p>}
                <div className={styles.submitBtnWrap}>
                    <CustomButton
                        text={t('buttons.verify')}
                        loading={loading}
                        disable={loading || code.length !== CODE_LENGTH}
                        styleType={BUTTON_STYLE_TYPE.PURPLE}
                    />
                </div>
            </form>
        </>
    );
};

export default VerifyAddedEmailStep;
